import { RouteConfig } from 'routes/routes';

import { PROFILES_ROUTE } from './list';
import Profiles from 'pages/profiles/profiles';

export const profilesRoutes: RouteConfig[] = [
  {
    path: PROFILES_ROUTE,
    element: <Profiles />,
    roles: [],
    permissions: {},
  },
];
